var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCasino = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M18.735 8.078c-3.642-2.706-5.25-4.978-6.263-6.8a.54.54 0 0 0-.944 0c-1.015 1.822-2.622 4.094-6.264 6.8-7.282 5.426-.428 12.994 5.593 8.806-.36 2.452-1.592 4.246-2.872 5.138a.53.53 0 0 0-.222.435v.004c0 .298.242.539.54.539h7.418a.54.54 0 0 0 .539-.54.53.53 0 0 0-.225-.437c-1.276-.875-2.487-2.689-2.87-5.14 5.998 4.19 12.853-3.379 5.57-8.805"
})));
export default SvgCasino;